
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/einterface/v5/[index]",
      function () {
        return require("private-next-pages/einterface/v5/[index].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/einterface/v5/[index]"])
      });
    }
  